import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Mail, Instagram } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQFooter() {
  const faqs = [{
    q: '¿Cómo recibo el Megapack después de comprar?',
    a: 'Inmediatamente después de tu compra, recibirás un correo electrónico con un enlace único para descargar todos los tomos y bonus en formato PDF. Podés acceder desde tu celular, tablet o computadora.'
  }, {
    q: '¿Sirve si todavía no cursé Contratos o recién empiezo?',
    a: 'Sí, es ideal. Te va a ahorrar semanas de leer material que no sirve. Vas a empezar la cursada sabiendo exactamente a qué temas prestarle atención en clase.'
  }, {
    q: '¿Necesito el libro de Lorenzetti o me alcanza con este pack?',
    a: 'El pack está diseñado para ser tu material principal de estudio. Resume la doctrina mayoritaria (incluyendo a Lorenzetti, Borda, Alterini) y la conecta directamente con los artículos del CCCN. Muchos alumnos aprueban solo estudiando de acá.'
  }, {
    q: '¿Los 6 bonus están incluidos en las dos opciones?',
    a: 'Solo está incluido en el Pack Full, que incluye los 6 bonus estratégicos gratis.'
  }, {
    q: '¿Sirve para cualquier facultad de Derecho de Argentina?',
    a: 'Sí. El programa de Contratos y Obligaciones está unificado por el Código Civil y Comercial de la Nación (CCCN). Los temas centrales (formación, vicios, nulidades, contratos típicos) se enseñan igual en la UBA, UNR, UNC, UCA, etc.'
  }, {
    q: '¿Sirve si tengo muy poco tiempo porque trabajo mientras estudio?',
    a: 'Especialmente diseñado para vos. El Cronograma de 15 y 7 días de emergencia te dice exactamente qué temas priorizar para aprobar cuando no tenés tiempo de leer todo.'
  }, {
    q: '¿Qué diferencia tiene con los resúmenes gratis que circulan en los grupos de la facu?',
    a: 'Los resúmenes gratis suelen estar desactualizados, tienen errores conceptuales graves y no te enseñan a resolver casos prácticos ni a rendir el oral. Este es un método integral creado por profesionales.'
  }, {
    q: '¿Tiene garantía real?',
    a: '100% real. Tenés 7 días desde la compra. Si sentís que no te sirve, nos mandás un mail y te devolvemos el dinero en el día, sin hacerte preguntas.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <>
      <section className="py-12 md:py-20 bg-slate-50" data-id="element-14">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-8 md:mb-12" data-id="element-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-slate-900 mb-2 md:mb-4" data-id="element-17">
              DUDAS COMUNES
            </h2>
            <p className="text-base md:text-xl text-slate-600" data-id="element-18">
              Preguntas Frecuentes
            </p>
          </motion.div>

          <div className="space-y-3 md:space-y-4" data-id="element-19">
            {faqs.map((faq, idx) => {
            const isOpen = openIdx === idx;
            return <motion.div key={idx} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.05
            }} className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-id="element-20">
                  <button className="w-full px-4 py-3 md:px-6 md:py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIdx(isOpen ? null : idx)} data-id="element-21">
                    <span className="font-bold text-sm md:text-base text-slate-900 pr-4 md:pr-8" data-id="element-22">
                      {faq.q}
                    </span>
                    <motion.div animate={{
                  rotate: isOpen ? 180 : 0
                }} data-id="element-23">
                      <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 flex-shrink-0 ${isOpen ? 'text-brand-500' : 'text-slate-400'}`} data-id="element-24" />
                    </motion.div>
                  </button>
                  <AnimatePresence data-id="element-25">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.2
                }} data-id="element-26">
                        <div className="px-4 pb-3 md:px-6 md:pb-4 text-sm md:text-base text-slate-600" data-id="element-27">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </motion.div>;
          })}
          </div>
        </div>
      </section>

      <footer className="bg-slate-900 text-slate-400 py-8 md:py-12 border-t border-slate-800" data-id="element-28">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
          <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-6 md:mb-8" data-id="element-30">
            <div data-id="element-31">
              <h4 className="text-white font-bold text-lg md:text-xl mb-3 md:mb-4 flex items-center gap-2" data-id="element-32">
                <span className="text-xl md:text-2xl" data-id="element-33">📚</span> Saber Click
              </h4>
              <p className="mb-4 max-w-sm text-sm md:text-base" data-id="element-34">
                El sistema de estudio N°1 para estudiantes de Abogacía en
                Argentina. Porque aprobar Contratos no debería costarte otro
                cuatrimestre perdido ni más noches de pánico antes del parcial.
              </p>
            </div>
            <div className="md:text-right" data-id="element-35">
              <h4 className="text-white font-bold mb-3 md:mb-4 text-sm md:text-base" data-id="element-36">
                Contacto
              </h4>
              <div className="flex flex-col md:items-end space-y-2 text-sm md:text-base" data-id="element-37">
                <a href="mailto:contacto@saberclick.com" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-38">
                  <Mail className="w-4 h-4" data-id="element-39" /> contacto@saberclick.com
                </a>
                <a href="#" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-40">
                  <Instagram className="w-4 h-4" data-id="element-41" /> @saberclick
                </a>
                <a href="https://saberclick.com" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-42">
                  saberclick.com
                </a>
              </div>
            </div>
          </div>
          <div className="pt-6 md:pt-8 border-t border-slate-800 text-xs md:text-sm text-center md:text-left flex flex-col md:flex-row justify-between items-center gap-4 md:gap-0" data-id="element-43">
            <p data-id="element-44">© SaberClick™ 2026 — Todos los derechos reservados.</p>
            <div className="space-x-4" data-id="element-45">
              <a href="#" className="hover:text-white transition-colors" data-id="element-46">
                Términos y Condiciones
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-47">
                Política de Privacidad
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>;
}